import { render, staticRenderFns } from "./HotelProductInfo.vue?vue&type=template&id=660916c4&scoped=true"
import script from "./HotelProductInfo.vue?vue&type=script&lang=js"
export * from "./HotelProductInfo.vue?vue&type=script&lang=js"
import style0 from "./HotelProductInfo.vue?vue&type=style&index=0&id=660916c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660916c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660916c4')) {
      api.createRecord('660916c4', component.options)
    } else {
      api.reload('660916c4', component.options)
    }
    module.hot.accept("./HotelProductInfo.vue?vue&type=template&id=660916c4&scoped=true", function () {
      api.rerender('660916c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/info/product/HotelProductInfo.vue"
export default component.exports